<template>
  <el-dialog :visible.sync="visible" width="660px" center :show-close="false"
             :before-close="colseTerm">
    <DialogsHeader title="临时术语表" />
    <el-table ref="termTable" :data="temporaryTermList" v-loading="loading" border height="288"
              header-row-class-name="header-row-style" cell-class-name="cell-row">
      <el-table-column label="序号" type="index" :index="indexMethod" align="center" width="55"
                       show-overflow-tooltip />
      <el-table-column label="原文" align="center">
        <template slot-scope="{row}">
          <!-- :contenteditable="row.isEditor"   @focus="handleFocus($event)" @blur="handleBlur($event,row,'sourceSent')"-->
          <div class="sourceSent" :class="targetRightViewClass('source')" :contenteditable="true"   @focus="handleFocus($event)" @blur="handleBlur($event,row,'sourceSent')"
               :type="`source-${row.id}`">
            {{row.sourceSent }}</div>
        </template>
      </el-table-column>
      <el-table-column label="译文" align="center">
        <template slot-scope="{row}">
          <div class="targetSent" :id="`targetSent-${row.id}`" :class="targetRightViewClass('target')" :type="`target-${row.id}`"
               :contenteditable="true" @focus="handleFocus($event)"
               @blur="handleBlur($event,row,'targetSent')">
            {{row.targetSent }}</div>
        </template>
      </el-table-column>
      <!-- prop="creatorName" show-overflow-tooltip-->
      <el-table-column label="添加人" align="center" width="92">
        <template slot-scope="{row}">
          <el-tooltip :disabled="showTooltip" effect="dark" :content="row.creatorName"
                      placement="top-start">
            <span style="white-space:nowrap;overflow:hidden;"
                  @mouseover="onShowNameTipsMouseenter($event)">{{row.creatorName}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="88" >
        <template slot-scope="{row}">
          <div class="icon-warp">
            <!-- <i class="icon-item editor-icon" @click="handleEditor(row)"></i> -->
            <i class="icon-item delete-icon" @click="handlerDelet(row)"></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button class="close" @click="colseTerm">取 消</el-button>
      <el-button class="confirm" @click="preservationTerm">保存至术语库</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DialogsHeader from '@/common/dialogsHeader';
import { termSentUpdate, batchDeleteByIdList, saveTemporaryTermLib } from '@/services/editorApi';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'termTable',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: { DialogsHeader },
  data () {
    return {
      SPECIAL_LANGUAGE: SPECIAL_LANGUAGE,
      loading: true,
      focusContext: '',
      pageParams: {
        filter: {
          // companyCode: '',
          fileId: null,
          // transModel: 1
        },
        page: 1,
        rows: 20
      },
      showTooltip: true,
      totalPage: 0,
      status: 1,//  0禁用 | 1允许
    }
  },
  computed: {
    ...mapGetters('editor', [
      'getUrlInfo',
      'getFileInfo',
      'getFileTaskInfo',
      'temporaryTermList',
      'getUserInfo'
    ]),
    getFileId () {
      let fileId = null;
      const { type } = this.getUrlInfo
      if (type === 'project') {
        fileId = this.getFileInfo.id
      } else if (type === 'task' || type === 'school') {
        fileId = this.getFileTaskInfo.fileId
      }
      return fileId
    }
  },
  watch: {
    visible (newValue) {
      if (!newValue) {
        this.pageParams.page = 1
        this.getTemporaryTermList([])
        return false
      } else {
        this.getList()
        this.handleScrollTable()
      }
    }
  },
  methods: {
    ...mapActions('editor', [
      'getTemporaryTermList'
    ]),
    /**
   * @desc 特殊语种样式处理
   * @param {source} 源语言/目标语言
   * @returns {string} 返回样式类名
   */
    targetRightViewClass (source) {
      const { sourceLang, targetLang } = this.getUrlInfo
      if (source === 'source') {
        return this.SPECIAL_LANGUAGE.indexOf(sourceLang) !== -1 ? 'right-view' : ''
      } else if (source === 'target') {
        return this.SPECIAL_LANGUAGE.indexOf(targetLang) !== -1 ? 'right-view' : ''
      }
    },
    onShowNameTipsMouseenter (e) {
      const target = e.target.parentNode;
      let clientWidth = target.clientWidth;
      let scrollWidth = target.scrollWidth;
      if (clientWidth < scrollWidth) {
        this.showTooltip = false;
      } else {
        this.showTooltip = true;
      }
    },
    handleScrollTable () {
      this.$nextTick(() => {
        this.$refs.termTable.bodyWrapper.addEventListener('scroll', async (e) => {
          let { target } = e
          let clientHeight = target.clientHeight;
          let scrollTop = target.scrollTop;
          let scrollHeight = target.scrollHeight;
          let flag = (clientHeight + scrollTop === scrollHeight) && (this.pageParams.page < this.totalPage) && this.status
          if (flag) {
            this.pageParams.page += 1
            this.getList()
          }
        })
      })
    },
    indexMethod (index) {
      if (index === 0) {
        return `0${index + 1}`
      } else {
        return index < 9 ? `0${index + 1}` : index + 1
      }
    },
    async getList () {
      this.loading = true
      this.pageParams.filter.fileId = this.getFileId
      const { success, totalPage } = await this.getTemporaryTermList(this.pageParams)
      if (success) {
        this.totalPage = totalPage
        this.loading = false
        this.status = 1
      }
    },
    //编辑术语
    handleEditor(row){
      row.isEditor = true
      this.$nextTick(() => {
        // document.querySelector('.targetSent').focus()
      //让光变自动移动到最后
      let notesDom = document.getElementById(`targetSent-${row.id}`)
      if (window.getSelection) {
        // 兼容 IE11 10 9 ff safari
        // notesDom.focus(); // 解决ff不获取焦点无法定位问题
        let range = window.getSelection(); // 创建range
        range.selectAllChildren(notesDom); // range 选择notesDom下所有子内容
        range.collapseToEnd(); // 光标移至最后
      } else if (document.selection) {
        // 兼容 IE10 9 8 7 6
        let range = document.selection.createRange(); // 创建选择对象
        range.moveToElementText(notesDom); // range定位到notesDom
        range.collapse(false); // 光标移至最后
        range.select();
      }
      })
    },
    //取消弹窗
    colseTerm () {
      this.status = 0
      this.$emit("handleClose");
    },
    //保存至术语库
    async preservationTerm () {
      // selfCompany 当前用户的团队信息
      // const { selfCompany } = this.getUserInfo
      if (this.temporaryTermList.length === 0) {
        this.$message.closeAll()
        this.$message.warning('当前没有可以保存的术语')
        return false
      }
      const params = {
        fileId: this.getFileId
        // companyCode: selfCompany.code
      }
      const { success } = await saveTemporaryTermLib(params)
      if (success) {
        this.status = 0
        this.$message.closeAll()
        this.$message.success('保存成功')
        this.$emit("handleConfirm")
      }
    },
    handleFocus (e) {
      this.focusContext = e.target.innerText.trim()
    },
    async handleBlur (e, row, type) {
      const { sourceSent, targetSent } = row
      const currentContext = e.target.innerText.trim()
      if (currentContext === this.focusContext) {
        this.focusContext = ''
        row.isEditor = false
        return false
      }
      if (currentContext === '') {
        this.$message.closeAll()
        this.$message.warning('修改内容不能为空!')
        e.target.innerText = this.focusContext
        // this.focusContext = ''
        row.isEditor = false
        return false
      }
      const params = {
        id: row.id,
      }
      if (type === 'sourceSent') {
        params.sourceSent = currentContext
        params.targetSent = targetSent
      } else {
        params.sourceSent = sourceSent
        params.targetSent = currentContext
      }
      const { success } = await termSentUpdate(params)
      if (success) {
        this.$message.closeAll()
        this.$message.success('编辑成功')
        row.isEditor = false
        this.getList()
      }
    },
    //删除
    async handlerDelet (row) {
      const params = {
        idList: [row.id]
      }
      const { success } = await batchDeleteByIdList(params)
      if (success) {
        this.$message.closeAll()
        this.$message.success('删除成功')
        this.pageParams.page = 1
        this.status = 0
        await this.getTemporaryTermList([])
        this.getList()
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  margin-top: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 12px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 15px 52px;
  }
  .el-dialog__footer {
    padding: 15px 20px 30px;
    .el-button + .el-button {
      margin-left: 30px;
    }
    .el-button {
      line-height: 0;
      height: 32px;
      border: 1px solid #0078fc;
      border-radius: 4px;
    }
    .close {
      width: 76px;
      color: #0078fc;
      &:hover {
        background-color: lighten(#0078fc, 40%);
      }
    }
    .confirm {
      width: 132px;
      color: #fff;
      background-color: #0078fc;
      &:hover {
        border: 1px solid lighten(#0078fc, 10%);
        background-color: lighten(#0078fc, 10%);
      }
    }
  }
  .el-table {
    margin-top: 18px;
    .header-row-style {
      th {
        padding: 0;
        line-height: 0;
        height: 48px;
        background: #f3f7fe;
      }
    }
    .cell-row {
      height: 48px;
    }
    .sourceSent,
    .targetSent {
      text-align: left;
      word-break: break-word;
    }
    .right-view {
      text-align: right;
      direction: rtl;
      unicode-bidi: bidi-override;
    }
    .icon-warp {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 20px;
      .icon-item {
        display: block;
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
      .icon-item + .icon-item {
        margin-left: 15px;
      }
      .editor-icon {
        background: url("../../assets/images/editor.png") no-repeat;
        &:hover {
          background: url("../../assets/images/editor_pre.png") no-repeat;
        }
      }
      .delete-icon {
        background: url("../../assets/images/delet.png") no-repeat;
        &:hover {
          background: url("../../assets/images/delet_pre.png") no-repeat;
        }
      }
    }
  }
}
</style>